import * as PersistentBarActionTypes from './action-types.constants';
import * as PersistentBarActions from './persistent-video-bar.actions';
import * as PlayerActionTypes from '../player/action-types.constants';
const { IntersectionObserver } = window;

function initObserver(storeAPI, container, player) {
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: [0, .25]
    }
    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            const { isIntersecting } = entry;
            const { offsetHeight } = player.amp.mediaElement;
            storeAPI.dispatch(PersistentBarActions.changeIntersection(isIntersecting,offsetHeight));
        });
    }
    let observer = new IntersectionObserver(callback, observerOptions);
    observer.observe(container);
    return observer;

}
const PersistentVideoBarMiddleware = (storeAPI) => {
    let container = null;
    let observer = null;
    let player = null;
    return next => action => {
        // Do something in here, when each action is dispatched
        //const state = storeAPI.getState();
        //console.log('[PersistentVideoBarMiddleware ] dispatching', action);

        let result = next(action);
        //const nextState = storeAPI.getState();
        switch (action.type) {
            case PersistentBarActionTypes.READY:
                container = action.container;
                if(player != null && observer == null) {
                    observer = initObserver(storeAPI,container,player);
                }
                break;

            case PlayerActionTypes.PLAYER_CREATED:
                player = action.player;
                if(container != null && observer == null) {
                    observer = initObserver(storeAPI,container,player);
                }
                break;

            case PlayerActionTypes.DESTROY_PLAYER: 
            case PersistentBarActionTypes.DESTROY:
                container = null;
                player = null;
                if(observer != null) {
                    observer.disconnect();
                    observer = null;
                }


        }
        return result
    }

}

export default PersistentVideoBarMiddleware;